import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const RecreatingApplicationPhase = memo(function RecreatingApplicationPhase({
  disabled,
  progressIcon,
  successIcon,
  errorIcon,
}: RecreatingApplicationPhaseProps): JSX.Element {
  return (
    <ServiceConnectionStep disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {progressIcon ? <CircularProgress size="24px" sx={{ mr: 1 }} /> : null}
        {successIcon ? (
          <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
        ) : null}
        {errorIcon ? (
          <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
        ) : null}
        <Typography variant="body1">
          (Re)-creating Okta App Integration...
        </Typography>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body1">
          If we already have an app ID for your Okta organization on file, we
          attempt to reference the app by ID and ensure that it has the
          requisite permissions.
        </Typography>
        <Typography variant="body1">
          If the app does not exist, we create an app called{" "}
          <strong>ThreatKey Integration</strong>.
        </Typography>
      </Box>
    </ServiceConnectionStep>
  );
});

export default RecreatingApplicationPhase;

// -----------------------------------------------------------------------------

interface RecreatingApplicationPhaseProps {
  disabled: boolean;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
